import React from 'react';
import { KTIcon } from '../../../_metronic/helpers';
import { FaRegEye, FaEdit } from "react-icons/fa";
import Barcode from 'react-barcode';
import moment from 'moment';

const SharedTable = ({ headers, data, renderActions, getDetail }) => {
  const className = 'mb-5 mb-xl-8';

  const capitalizeHeader = (header) => {
    return header.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, str => str.toUpperCase());
  };

  return (
    <div className="card-body py-3">
      <div className="table-responsive">
        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
          <thead>
            <tr className="fw-bold text-muted">
              {headers.map((header, index) => (
                <th key={index} className="min-w-150px">
                  {capitalizeHeader(header)}
                </th>
              ))}
              {/* <th className="min-w-100px text-end">Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {data?.map((row) => (
              <tr key={row._id}>
                {headers.map((header, index) => (
                  <td key={index} className='text-capitalize'>
                    {header === 'view' ? (
                      <div className="bg-hover-body" onClick={() => getDetail(row)}>
                        <FaRegEye size={20} />
                      </div>
                    ) : header === 'barcode' ? (
                      <Barcode value={row.deviceId} format="CODE128" displayValue={false} />
                    ) : row[header] instanceof Date || moment(row[header], moment.ISO_8601, true).isValid() ? (
                      moment(row[header]).format("YYYY-MM-DD")
                    ) : (row[header] !== undefined && row[header] !== null && row[header] !== '')
                      ? (row[header]) :
                      '--'
                    }
                  </td>
                ))}
                <td className="text-end">
                  {renderActions && (
                    renderActions(row)
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export { SharedTable };
